module.exports = __webpack_public_path__ + "img/logo-um-fgpa.ec2b2cb9.png";